import { loadablePage } from 'src/utils/loadable';

export default loadablePage(
  () =>
    import(
      /* webpackChunkName: "PurchaseFlowModal" */ /* webpackPrefetch: true */
      './FindOutMoreModal.component'
    ),
);
